<template>
    <card color="blue" activated :link="linkObject">
        <ul v-if="updates" class="legislation-updates">
            <li
                v-for="(update, index) in updates"
                :key="index"
                class="legislation-update"
            >
                <a :href="update.url">{{ update.name }}</a>
            </li>
        </ul>
        <p v-else class="p-3">Geen nieuws op geabbonneerde legislations</p>
    </card>
</template>

<script>
import card from '@/components/cards/card';

export default {
    components: {
        card
    },

    props: {
        updates: {
            type: Array,
            default() {
                return [];
            }
        },
        dashboardUrl: {
            type: String,
            default() {
                return '';
            }
        },
        dashboardName: {
            type: String,
            default() {
                return '';
            }
        }
    },
    computed: {
        linkObject() {
            return {
                text: this.dashboardName,
                url: this.dashboardUrl
            };
        }
    }
};
</script>

<style lang="scss">
.legislation-updates {
    padding: 0;
    list-style: none;
    line-height: 2.75;
}

.legislation-update {
    position: relative;
    background-color: $brand-white;

    a {
        padding-left: 40px;
        display: block;
    }

    &:hover {
        background-color: $brand-blue;

        a {
            color: $brand-white;
        }
    }

    &:nth-child(even):hover {
        background-color: $brand-blue;
    }

    &:nth-child(even) {
        background-color: $brand-gray;
    }

    &--unread:before {
        content: '';
        display: block;
        position: absolute;
        top: 17px;
        left: 16px;
        width: 10px;
        height: 10px;
        border-radius: 5px;
        background-color: $brand-blue;
    }
}
</style>

<style lang="scss" scoped>
::v-deep .card__text {
    flex: 1 0 auto;
    padding: 0;
}
</style>
